module.exports = __webpack_public_path__ + "img/success1.e71cbf23.gif";